import { jsx as l, Fragment as Nt, jsxs as st } from "react/jsx-runtime";
import { ChangeCircle as re } from "@mui/icons-material";
import { Box as P } from "@mui/material";
import { OverlayViewF as se } from "@react-google-maps/api";
import { useState as N, useRef as v, useCallback as j, useEffect as z, useMemo as at } from "react";
import { INDOOR_VISIBILITY_ZOOM_THRESHOLD as ae } from "./constants.js";
import { overlayWrapperStyles as L } from "./styles.js";
const ce = 100, Le = ({
  id: Ht,
  map: s,
  floorPlanUrl: b,
  rfPlanUrl: ct,
  sinrPlanUrl: it,
  dominantCellPlanUrl: lt,
  customPlanUrl: gt,
  floorPlanOpacity: Et,
  rfPlanOpacity: jt,
  sinrPlanOpacity: zt = 0,
  dominantCellPlanOpacity: Ct = 0,
  customPlanOpacity: Ot = 0,
  rotation: U,
  setRotation: ut,
  skewX: A,
  skewY: V,
  onPositionChange: G,
  onBoundsChange: y,
  isActive: Z,
  inactiveOpacity: Yt,
  bounds: X,
  zIndex: tt,
  visibilityZoomThreshold: ft = ae
}) => {
  const [a, C] = N(X), [H, mt] = N(!1), [O, dt] = N(!1), [Zt, Lt] = N(null), [J, It] = N(null), [q, Xt] = N(null), [ht, wt] = N(!1), [k, pt] = N(U), [I, Ft] = N(!1), Pt = v(!1), et = v(1), vt = v(!1), nt = v(null), F = v(null), $t = v(null), bt = v(null), K = v(X), ot = v(!1), rt = v(!1), D = v(null), $ = v([]), W = j((t, n) => {
    window.addEventListener(t, n), $.current.push([t, n]);
  }, []), B = j((t, n) => {
    window.removeEventListener(t, n), $.current = $.current.filter(([e, f]) => !(e === t && f === n));
  }, []);
  z(() => () => {
    $.current.forEach(([t, n]) => window.removeEventListener(t, n)), $.current = [];
  }, []), z(() => (D.current || (D.current = document.createElement("style"), document.head.appendChild(D.current)), O ? D.current.textContent = `
        body, html, #map, .gm-style, .gm-style > div, .gm-style > div > div, .gm-style > div > div > div {
          cursor: crosshair !important;
        }
      ` : H ? D.current.textContent = `
        body, html, #map, .gm-style, .gm-style > div, .gm-style > div > div, .gm-style > div > div > div {
          cursor: move !important;
        }
      ` : D.current.textContent = "", () => {
    D.current && (D.current.textContent = "");
  }), [O, H]), z(() => () => {
    D.current?.remove(), D.current = null;
  }, []);
  const Q = j((t) => {
    if (t)
      try {
        return t instanceof google.maps.LatLngBounds ? t : "north" in t && "south" in t ? new google.maps.LatLngBounds(new google.maps.LatLng(t.south, t.west), new google.maps.LatLng(t.north, t.east)) : "northeast" in t && "southwest" in t ? new google.maps.LatLngBounds(new google.maps.LatLng(t.southwest.lat, t.southwest.lng), new google.maps.LatLng(t.northeast.lat, t.northeast.lng)) : void 0;
      } catch (n) {
        console.error("Error ensuring valid bounds:", n);
        return;
      }
  }, []);
  z(() => {
    pt(U);
  }, [U]), z(() => {
    if (X && !Pt.current) {
      const t = Q(X);
      t && (C(t), K.current = t, Pt.current = !0);
    }
  }, [X, Q]), z(() => {
    (H || O) && (ot.current = !0);
  }, [H, O]), z(() => {
    if (!s) return;
    const t = () => {
      const e = s.getZoom();
      Ft(e !== void 0 && e < ft);
    };
    t();
    const n = s.addListener("zoom_changed", t);
    return () => {
      google.maps.event.removeListener(n);
    };
  }, [s, ft]);
  const At = j((t) => {
    const n = t.target, e = n.naturalWidth, f = n.naturalHeight;
    It({
      width: e,
      height: f
    });
    const w = e / f;
    if (et.current = w, vt.current = !0, a && s)
      try {
        const o = s.getProjection();
        if (o) {
          const i = a.getSouthWest(), c = a.getNorthEast(), p = a.getCenter();
          if (i && c && p) {
            const g = s.getZoom() || 0, h = Math.pow(2, g), R = o.fromLatLngToPoint(i), m = o.fromLatLngToPoint(c);
            if (R && m) {
              const r = Math.abs(m.x - R.x) * h, x = r / w, u = o.fromLatLngToPoint(p);
              if (u) {
                const d = r / 2 / h, M = x / 2 / h, _ = new google.maps.Point(u.x + d, u.y - M), E = new google.maps.Point(u.x - d, u.y + M), Y = o.fromPointToLatLng(_), S = o.fromPointToLatLng(E);
                if (Y && S) {
                  const T = new google.maps.LatLngBounds(S, Y);
                  C(T), y(T);
                }
              }
            }
          }
        }
      } catch (o) {
        console.error("Error adjusting bounds:", o);
      }
  }, [s, a, y]), Vt = j((t) => {
    const n = t.target, e = n.naturalWidth, f = n.naturalHeight;
    if (Xt({
      width: e,
      height: f
    }), !b) {
      const w = e / f;
      if (et.current = w, vt.current = !0, a && s)
        try {
          const o = s.getProjection();
          if (o) {
            const i = a.getSouthWest(), c = a.getNorthEast(), p = a.getCenter();
            if (i && c && p) {
              const g = s.getZoom() || 0, h = Math.pow(2, g), R = o.fromLatLngToPoint(i), m = o.fromLatLngToPoint(c);
              if (R && m) {
                const r = Math.abs(m.x - R.x) * h, x = r / w, u = o.fromLatLngToPoint(p);
                if (u) {
                  const d = r / 2 / h, M = x / 2 / h, _ = new google.maps.Point(u.x + d, u.y - M), E = new google.maps.Point(u.x - d, u.y + M), Y = o.fromPointToLatLng(_), S = o.fromPointToLatLng(E);
                  if (Y && S) {
                    const T = new google.maps.LatLngBounds(S, Y);
                    C(T), y(T);
                  }
                }
              }
            }
          }
        } catch (o) {
          console.error("Error adjusting bounds:", o);
        }
    }
  }, [s, a, y, b]), Gt = j((t) => {
    if (t.preventDefault(), t.stopPropagation(), !s || !a) return;
    mt(!0);
    const n = {
      x: t.clientX,
      y: t.clientY
    }, e = a.toJSON(), f = {
      value: new google.maps.LatLngBounds(new google.maps.LatLng(e.south, e.west), new google.maps.LatLng(e.north, e.east))
    }, w = (i) => {
      if (!s) return;
      i.preventDefault(), i.stopPropagation();
      const c = i.clientX - n.x, p = i.clientY - n.y, g = s.getProjection();
      if (!g) return;
      const h = new google.maps.LatLng(e.north, e.east), R = new google.maps.LatLng(e.south, e.west), m = g.fromLatLngToPoint(h), r = g.fromLatLngToPoint(R);
      if (!m || !r) return;
      const x = Math.pow(2, s.getZoom() || 0), u = c / x, d = p / x;
      m.x += u, m.y += d, r.x += u, r.y += d;
      const M = g.fromPointToLatLng(m), _ = g.fromPointToLatLng(r);
      if (!M || !_) return;
      const E = new google.maps.LatLngBounds(_, M);
      f.value = E, C(E);
    }, o = () => {
      B("mousemove", w), B("mouseup", o);
      const i = f.value;
      if (i) {
        C(i), K.current = i;
        const c = i.getCenter();
        c && G(c.lat(), c.lng()), rt.current = !0, ot.current = !0, y(i);
      }
      mt(!1);
    };
    W("mousemove", w), W("mouseup", o);
  }, [s, a, G, y, W, B]);
  z(() => {
    !H && rt.current && a && (rt.current = !1, setTimeout(() => {
      y(a);
    }, 0));
  }, [H, a, y]);
  const Jt = j((t) => {
    if (t.preventDefault(), t.stopPropagation(), !F.current || !a) return;
    const n = F.current.getBoundingClientRect(), e = n.left + n.width / 2, f = n.top + n.height / 2, w = Math.atan2(t.clientY - f, t.clientX - e), o = k, i = {
      value: o
    };
    wt(!0);
    const c = (g) => {
      g.preventDefault(), g.stopPropagation();
      const m = (Math.atan2(g.clientY - f, g.clientX - e) - w) * (180 / Math.PI), r = o + m;
      i.value = r, pt(r), nt.current && (nt.current.style.transform = `rotate(${r}deg) skew(${A}deg, ${V}deg)`);
    }, p = () => {
      B("mousemove", c), B("mouseup", p), ut(i.value), wt(!1);
    };
    W("mousemove", c), W("mouseup", p);
  }, [a, k, ut, A, V, W, B]), qt = j((t, n) => {
    if (t.preventDefault(), t.stopPropagation(), !s || !a || !F.current) return;
    const e = F.current.getBoundingClientRect(), f = t.clientX, w = t.clientY, o = e.left + e.width / 2, i = e.top + e.height / 2, c = a.toJSON(), p = et.current || (J ? J.width / J.height : q ? q.width / q.height : 1), g = Math.sqrt(Math.pow(f - o, 2) + Math.pow(w - i, 2));
    dt(!0), Lt(n);
    const h = {
      value: new google.maps.LatLngBounds(new google.maps.LatLng(c.south, c.west), new google.maps.LatLng(c.north, c.east))
    }, R = (r) => {
      if (r.preventDefault(), r.stopPropagation(), !s) return;
      const u = Math.sqrt(Math.pow(r.clientX - o, 2) + Math.pow(r.clientY - i, 2)) / g, d = s.getProjection();
      if (!d) return;
      const M = s.getZoom() || 0, _ = Math.pow(2, M), E = new google.maps.LatLng(c.north, c.east), Y = new google.maps.LatLng(c.south, c.west), S = d.fromLatLngToPoint(E), T = d.fromLatLngToPoint(Y);
      if (!S || !T) return;
      const yt = (S.x + T.x) / 2, Dt = (S.y + T.y) / 2, te = Math.abs(S.x - T.x) * _, Mt = Math.max(te * u, ce), ee = Mt / p, _t = Mt / (2 * _), St = ee / (2 * _), ne = new google.maps.Point(yt + _t, Dt - St), oe = new google.maps.Point(yt - _t, Dt + St), Tt = d.fromPointToLatLng(oe), Wt = d.fromPointToLatLng(ne);
      if (!Tt || !Wt) return;
      const Bt = new google.maps.LatLngBounds(Tt, Wt);
      h.value = Bt, C(Bt);
    }, m = () => {
      B("mousemove", R), B("mouseup", m);
      const r = h.value;
      if (r) {
        C(r), K.current = r;
        const x = r.getCenter();
        x && G(x.lat(), x.lng()), ot.current = !0, y(r);
      }
      dt(!1), Lt(null);
    };
    W("mousemove", R), W("mouseup", m);
  }, [s, a, J, q, y, G, W, B]), kt = ({
    corner: t
  }) => {
    const n = Zt === t;
    return /* @__PURE__ */ l(P, { sx: L.resizeHandle(n, I, t), onMouseDown: (e) => {
      e.preventDefault(), e.stopPropagation(), qt(e, t);
    } });
  }, Kt = () => /* @__PURE__ */ l(P, { sx: L.rotateHandle(I), onMouseDown: (t) => {
    t.preventDefault(), t.stopPropagation(), Jt(t);
  }, children: /* @__PURE__ */ l(
    re,
    {
      sx: {
        ...L.rotateHandleIcon,
        fontSize: "20px"
      }
    }
  ) }), Qt = () => /* @__PURE__ */ l(P, { sx: L.zoomIndicator(I && Z), children: "Zoom in to view" }), Ut = at(() => `rotate(${k}deg) skew(${A}deg, ${V}deg)`, [k, A, V]), Rt = at(() => H || O || ht, [H, O, ht]), xt = at(() => a || K.current, [a]);
  return /* @__PURE__ */ l(Nt, { children: s && Q(xt) && /* @__PURE__ */ l(se, { mapPaneName: Z ? "overlayMouseTarget" : "overlayLayer", bounds: Q(xt), zIndex: tt || (Z ? 1e3 : 1), children: /* @__PURE__ */ l(P, { ref: F, sx: L.imageContainer(Z, Yt, Rt, tt), children: /* @__PURE__ */ l(P, { ref: nt, "data-overlay-id": Ht, sx: L.overlayContainer(Ut, Rt, tt), children: /* @__PURE__ */ st("div", { style: L.contentWrapper, children: [
    /* @__PURE__ */ st(P, { sx: L.imageWrapper(Z), children: [
      b && /* @__PURE__ */ l(P, { component: "img", ref: $t, src: b, alt: "floor plan overlay", sx: L.planImage(Et), draggable: !1, onLoad: At }),
      ct && /* @__PURE__ */ l(P, { component: "img", ref: bt, src: ct, alt: "RF plan overlay", sx: L.planImage(jt), draggable: !1, onLoad: Vt }),
      it && /* @__PURE__ */ l(P, { component: "img", src: it, alt: "SINR plan overlay", sx: L.planImage(zt), draggable: !1 }),
      lt && /* @__PURE__ */ l(P, { component: "img", src: lt, alt: "Dominant cell plan overlay", sx: L.planImage(Ct), draggable: !1 }),
      gt && /* @__PURE__ */ l(P, { component: "img", src: gt, alt: "Custom plan overlay", sx: L.planImage(Ot), draggable: !1 })
    ] }),
    Z && /* @__PURE__ */ st(Nt, { children: [
      !I && /* @__PURE__ */ l(Kt, {}),
      ["topLeft", "topRight", "bottomLeft", "bottomRight"].map((t) => /* @__PURE__ */ l(kt, { corner: t }, t)),
      /* @__PURE__ */ l(Qt, {}),
      /* @__PURE__ */ l(P, { sx: L.dragArea(I, O), onMouseDown: I ? void 0 : Gt })
    ] })
  ] }) }) }) }) });
};
export {
  Le as OverlayWrapper
};
